import { http } from './index'

export const REPORT_DATA_ENDPOINT = 'api/reports/view/'
export const EXPIRED_DATA_ENDPOINT = '/expired'

export const getReportData = (url) => http.get(`${url}`)
